var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ProblemLevel, PostMessageType } from "@common/enums/base";
import { observable, action, runInAction, computed } from "mobx";
import http, { Api, Q } from "@http";
import { toCamelCaseData } from "@common/utils";
import { iframePostMessage } from '@common/utils';
var ProblemStore = /** @class */ (function () {
    function ProblemStore() {
        this.level = ProblemLevel.LevelOne;
        this.lastLevel = null;
        this.levelOneId = null;
        this.levelOneName = '';
        this.levelTwoId = null;
        this.levelTwoName = '';
        this.levelThreeId = null;
        this.levelThreeName = '';
        this.serviceCategoryId = null;
        this.serviceTypeId = null;
        this.serviceCodeId = null;
        this.currentIconUrl = '';
        this.serviceCombinationAliasId = '';
        this.isAliasingView = true;
        this.videoTitle = '';
        this.videoURL = '';
        this.howToVideoVisible = false;
        this.levelOneAliasList = [];
        this.levelTwoAliasList = [];
        this.levelThreeAliasList = [];
        this.serviceCodeWOType = null;
        this.loading = false;
        this.selectAlias = null;
        this.isChangeServiceComboByQuestion = null;
        this.beforeServiceCodeId = null;
    }
    Object.defineProperty(ProblemStore.prototype, "problemCaseCadeName", {
        get: function () {
            var tempName = '';
            if (!this.levelThreeId && this.levelTwoName) {
                tempName = this.levelOneName + " > " + this.levelTwoName;
            }
            else if (this.levelThreeId && this.levelTwoId) {
                tempName = this.levelOneName + " > " + this.levelTwoName + " > " + this.levelThreeName;
            }
            return tempName;
        },
        enumerable: false,
        configurable: true
    });
    ProblemStore.prototype.setServiceComboByQuestionData = function (isChangeServiceComboByQuestion) {
        this.isChangeServiceComboByQuestion = isChangeServiceComboByQuestion;
        this.beforeServiceCodeId = isChangeServiceComboByQuestion ? this.serviceCodeId : null;
    };
    ProblemStore.prototype.browserBack = function () {
        switch (this.level) {
            case ProblemLevel.LevelThree:
                this.levelThreeId = null;
                this.levelThreeName = '';
                this.serviceCodeId = null;
                this.currentIconUrl = '';
                break;
            case ProblemLevel.LevelTwo:
                this.levelTwoId = null;
                this.levelTwoName = '';
                this.levelThreeId = null;
                this.levelThreeName = '';
                this.serviceTypeId = null;
                this.serviceCodeId = null;
                this.levelThreeAliasList = [];
                this.currentIconUrl = '';
                break;
        }
    };
    ProblemStore.prototype.clear = function () {
        this.initProblem();
    };
    ProblemStore.prototype.initProblem = function () {
        this.level = ProblemLevel.LevelOne;
        this.levelOneId = null;
        this.levelOneName = '';
        this.levelTwoId = null;
        this.levelTwoName = '';
        this.levelThreeId = null;
        this.levelThreeName = '';
        this.serviceCategoryId = null;
        this.serviceTypeId = null;
        this.serviceCodeId = null;
        this.currentIconUrl = '';
        this.serviceCombinationAliasId = '';
        this.levelOneAliasList = [];
        this.levelTwoAliasList = [];
        this.levelThreeAliasList = [];
        this.isAliasingView = true;
    };
    ProblemStore.prototype.onChangeServiceCombo = function (serviceComboData, param) {
        var _this = this;
        runInAction(function () {
            if (!(serviceComboData === null || serviceComboData === void 0 ? void 0 : serviceComboData.serviceCategoryAliasId)) {
                var typeId = serviceComboData.serviceCodeId ? serviceComboData.serviceTypeId : null;
                _this.isAliasingView = false;
                _this.levelOneId = serviceComboData.serviceCategoryId;
                _this.levelOneName = serviceComboData.serviceCategoryName;
                _this.levelTwoId = typeId;
                _this.levelTwoName = serviceComboData.serviceCodeId ? serviceComboData.serviceTypeName : '';
                _this.levelThreeId = null;
                _this.levelThreeName = null;
                _this.serviceCategoryId = serviceComboData.serviceCategoryId;
                _this.serviceTypeId = typeId;
                _this.serviceCodeId = null;
                _this.isAliasingView = false;
                Promise.all([_this.handleLevelData(ProblemLevel.LevelOne),
                    _this.handleLevelData(ProblemLevel.LevelTwo), serviceComboData.serviceCodeId && _this.handleLevelData(ProblemLevel.LevelThree)]);
            }
            else {
                var typeParams = __assign(__assign({}, param), { parentId: serviceComboData === null || serviceComboData === void 0 ? void 0 : serviceComboData.serviceCategoryAliasId, level: ProblemLevel.LevelTwo });
                var codeParams = __assign(__assign({}, param), { parentId: serviceComboData === null || serviceComboData === void 0 ? void 0 : serviceComboData.serviceTypeAliasId, level: ProblemLevel.LevelThree });
                _this.isAliasingView = true;
                var promises = [_this.getClientServiceComboAlias(typeParams, ProblemLevel.LevelTwo)];
                if (serviceComboData.serviceCodeAliasId) {
                    _this.levelOneId = serviceComboData.serviceCategoryAliasId;
                    _this.levelOneName = serviceComboData.serviceCategoryAlias;
                    promises.push(_this.getClientServiceComboAlias(codeParams, ProblemLevel.LevelThree));
                }
                Promise.all(promises).then(function () {
                    var _a, _b;
                    if (!serviceComboData.serviceCodeAliasId) {
                        var aliasSelectCategoryData = (_a = _this.levelOneAliasList) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.id === (serviceComboData === null || serviceComboData === void 0 ? void 0 : serviceComboData.serviceCategoryAliasId); });
                        _this.setProblemAlias(aliasSelectCategoryData, ProblemLevel.LevelOne);
                        return;
                    }
                    var aliasSelectTypeData = (_b = _this.levelTwoAliasList) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.id === (serviceComboData === null || serviceComboData === void 0 ? void 0 : serviceComboData.serviceTypeAliasId); });
                    _this.setProblemAlias(aliasSelectTypeData, ProblemLevel.LevelTwo);
                });
            }
        });
    };
    ProblemStore.prototype.backLevelQuestion = function (level) {
        if (level === ProblemLevel.LevelOne) {
            this.level = ProblemLevel.LevelOne;
            this.levelOneId = null;
            this.levelOneName = '';
            this.levelTwoId = null;
            this.levelTwoName = '';
        }
        else if (level === ProblemLevel.LevelTwo) {
            this.level = ProblemLevel.LevelTwo;
            this.levelTwoId = null;
            this.levelTwoName = '';
        }
    };
    ProblemStore.prototype.setProblemLevel = function (level) {
        this.level = level;
    };
    ProblemStore.prototype.setLastLevel = function (level) {
        this.lastLevel = level;
    };
    ProblemStore.prototype.getClientServiceComboAlias = function (param, level) {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        if (!this.isAliasingView) return [3 /*break*/, 2];
                        promise = this.api().getClientServiceComboAlias(param);
                        return [4 /*yield*/, promise];
                    case 1:
                        data_1 = _a.sent();
                        runInAction(function () {
                            _this.loading = false;
                            if (data_1.isSuccess) {
                                data_1.body && _this.handleLevelAliasData(data_1.body, level);
                                if ((!data_1.body || !data_1.body.length) && level === ProblemLevel.LevelOne) {
                                    _this.isAliasingView = false;
                                    _this.handleLevelData(level);
                                }
                            }
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        this.handleLevelData(level);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProblemStore.prototype.handleLevelAliasData = function (data, level) {
        var targetData = this.removeAliasDuplicate(data);
        switch (level) {
            case ProblemLevel.LevelOne:
                this.levelOneAliasList = targetData;
                break;
            case ProblemLevel.LevelTwo:
                this.levelTwoAliasList = targetData;
                break;
            case ProblemLevel.LevelThree:
                this.levelThreeAliasList = targetData;
                break;
        }
    };
    ProblemStore.prototype.removeAliasDuplicate = function (list) {
        var map = new Map();
        var tempList = [];
        list.forEach(function (item) {
            if (!map.has(item.id)) {
                map.set(item.id, true);
                tempList.push(item);
            }
        });
        return tempList;
    };
    ProblemStore.prototype.handleLevelData = function (level) {
        return __awaiter(this, void 0, void 0, function () {
            var data, _a, _b, _c, _d;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        data = [];
                        _a = level;
                        switch (_a) {
                            case ProblemLevel.LevelOne: return [3 /*break*/, 1];
                            case ProblemLevel.LevelTwo: return [3 /*break*/, 3];
                            case ProblemLevel.LevelThree: return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1:
                        _b = toCamelCaseData;
                        return [4 /*yield*/, this.api().getAllServiceCategory()];
                    case 2:
                        data = _b.apply(void 0, [_e.sent()]);
                        runInAction(function () {
                            if (data && typeof (data) !== 'string') {
                                _this.levelOneAliasList = data;
                                _this.isAliasingView = false;
                            }
                            _this.loading = false;
                        });
                        return [3 /*break*/, 7];
                    case 3:
                        _c = toCamelCaseData;
                        return [4 /*yield*/, this.api().getServiceTypeByCategoryId(this.levelOneId)];
                    case 4:
                        data = _c.apply(void 0, [_e.sent()]);
                        runInAction(function () {
                            if (data && typeof (data) !== 'string') {
                                _this.levelTwoAliasList = data;
                            }
                            _this.loading = false;
                        });
                        return [3 /*break*/, 7];
                    case 5:
                        _d = toCamelCaseData;
                        return [4 /*yield*/, this.api().getServiceCodeByCategoryIdAndTypeId(this.levelOneId, this.levelTwoId)];
                    case 6:
                        data = _d.apply(void 0, [_e.sent()]);
                        runInAction(function () {
                            if (data && typeof (data) !== 'string') {
                                _this.levelThreeAliasList = data;
                            }
                            _this.loading = false;
                        });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ProblemStore.prototype.setProblemAlias = function (alias, level) {
        var _a, _b, _c, _d;
        switch (level) {
            case ProblemLevel.LevelOne:
                this.levelOneId = alias.id;
                this.levelOneName = alias.name;
                this.levelTwoId = null;
                this.levelTwoName = null;
                this.levelThreeId = null;
                this.levelThreeName = null;
                this.serviceCategoryId = null;
                this.serviceTypeId = null;
                this.serviceCodeId = null;
                break;
            case ProblemLevel.LevelTwo:
                this.levelTwoId = alias.id;
                this.levelTwoName = alias.name;
                this.levelThreeId = null;
                this.levelThreeName = null;
                if (alias.isLeafNode) { // has ServiceCode/Level three complete choose service combo
                    this.serviceCategoryId = alias.serviceCombo.serviceCategoryId;
                    this.serviceTypeId = alias.serviceCombo.serviceTypeId;
                    this.serviceCodeId = alias.serviceCombo.serviceCodeId;
                    this.currentIconUrl = alias.iconUrl;
                    this.serviceCombinationAliasId = alias.id ? alias.id.toString() : '';
                    this.videoTitle = (_a = alias.serviceCombo) === null || _a === void 0 ? void 0 : _a.videoTitle;
                    this.videoURL = (_b = alias.serviceCombo) === null || _b === void 0 ? void 0 : _b.videoURL;
                }
                else {
                    this.serviceCategoryId = null;
                    this.serviceTypeId = null;
                    this.serviceCodeId = null;
                    this.videoTitle = '';
                    this.videoURL = '';
                }
                break;
            case ProblemLevel.LevelThree:
                this.levelThreeId = alias.id;
                this.levelThreeName = alias.name;
                if (this.isAliasingView) {
                    this.serviceCategoryId = alias.serviceCombo.serviceCategoryId;
                    this.serviceTypeId = alias.serviceCombo.serviceTypeId;
                    this.serviceCodeId = alias.serviceCombo.serviceCodeId;
                    this.currentIconUrl = alias.iconUrl;
                    this.serviceCombinationAliasId = alias.id ? alias.id.toString() : '';
                }
                else {
                    // No AliasName
                    this.serviceCategoryId = this.levelOneId;
                    this.serviceTypeId = this.levelTwoId;
                    this.serviceCodeId = alias.id;
                    this.currentIconUrl = '';
                    this.serviceCombinationAliasId = '';
                }
                this.videoTitle = (_c = alias.serviceCombo) === null || _c === void 0 ? void 0 : _c.videoTitle;
                this.videoURL = (_d = alias.serviceCombo) === null || _d === void 0 ? void 0 : _d.videoURL;
                break;
        }
    };
    ProblemStore.prototype.getServiceCodeWOType = function (serviceCombo) {
        return __awaiter(this, void 0, void 0, function () {
            var param, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        param = this.isAliasingView ? serviceCombo.serviceCombo : {
                            serviceCategoryId: this.serviceCategoryId,
                            serviceTypeId: this.serviceTypeId,
                            serviceCodeId: serviceCombo.id
                        };
                        return [4 /*yield*/, this.api().getServiceCodeWOType(param)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.serviceCodeWOType = data;
                        });
                        return [2 /*return*/, data];
                }
            });
        });
    };
    ProblemStore.prototype.revertProblemData = function (tempWO) {
        this.serviceCombinationAliasId = tempWO.serviceCombinationAliasId;
        this.serviceCategoryId = tempWO.serviceCategoryId;
        this.serviceTypeId = tempWO.serviceTypeId;
        this.serviceCodeId = tempWO.serviceCodeId;
        this.currentIconUrl = tempWO.currentIconUrl;
    };
    ProblemStore.prototype.setProblemData = function (tempWO) {
        this.serviceCategoryId = tempWO.serviceCombination.serviceCategoryId;
        this.serviceTypeId = tempWO.serviceCombination.serviceTypeId;
        this.serviceCodeId = tempWO.serviceCombination.serviceCodeId;
        this.currentIconUrl = tempWO.serviceCombinationAlias && tempWO.serviceCombinationAlias.serviceCodeIconUrl;
        this.serviceCombinationAliasId = tempWO.serviceCombinationAliasId && String(tempWO.serviceCombinationAliasId);
    };
    ProblemStore.prototype.setHowToVideoVisible = function (data) {
        this.howToVideoVisible = data;
    };
    ProblemStore.prototype.setSelectAlias = function (data) {
        this.selectAlias = data;
    };
    ProblemStore.prototype.howToVideoCreateCancelWO = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().simpleCommit({
                            serviceCombinationAliasId: this.serviceCombinationAliasId,
                            serviceCategoryId: this.serviceCategoryId,
                            serviceTypeId: this.serviceTypeId,
                            serviceCodeId: this.serviceCodeId,
                            wo: {
                                problemDescription: this.problemCaseCadeName,
                                cancelReason: "Resident Troubleshoot using the App"
                            },
                            isCancel: true
                        })];
                    case 1:
                        data = _a.sent();
                        if (data && typeof data !== 'string') {
                            iframePostMessage(PostMessageType.WoCreate_submit);
                        }
                        return [2 /*return*/, data];
                }
            });
        });
    };
    ProblemStore.prototype.createWoServiceComboEventlog = function (woId) {
        if (this.isChangeServiceComboByQuestion === null)
            return;
        var data = [{
                woId: woId,
                isChanged: this.isChangeServiceComboByQuestion,
                beforeServiceCodeId: this.beforeServiceCodeId,
                afterServiceCodeId: this.serviceCodeId
            }];
        this.api().createWoServiceComboEventlog(data);
    };
    ProblemStore.prototype.api = function () {
        return {
            getClientServiceComboAlias: function (params) {
                return Q(http.get("RSP/NewRequest/GetClientServiceComboAlias", { params: params }));
            },
            getAllServiceCategory: function () {
                return Q(http.get("RSP/NewRequest/allServiceCategory"));
            },
            getServiceTypeByCategoryId: function (serviceCategoryId) {
                return Q(http.get("RSP/NewRequest/" + serviceCategoryId + "/allServiceType"));
            },
            getServiceCodeByCategoryIdAndTypeId: function (serviceCategoryId, serviceTypeId) {
                return Q(http.get("RSP/NewRequest/" + serviceCategoryId + "/" + serviceTypeId + "/allServiceCode"));
            },
            getServiceCodeWOType: function (param) {
                return Q(http.post("RSP/NewRequest/" + param.serviceCategoryId + "/" + param.serviceTypeId + "/" + param.serviceCodeId + "/serviceCodeWOType"));
            },
            simpleCommit: function (data) {
                return Q(http.post("/RSP/NewRequest/reactiveWo/SimpleCommit", data, __assign({}, Api.withForm)));
            },
            createWoServiceComboEventlog: function (data) {
                return Q(http.post("/RSP/NewRequest/service-combination-eventlog", data));
            },
        };
    };
    __decorate([
        observable
    ], ProblemStore.prototype, "level", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "lastLevel", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "levelOneId", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "levelOneName", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "levelTwoId", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "levelTwoName", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "levelThreeId", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "levelThreeName", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "serviceCategoryId", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "serviceTypeId", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "serviceCodeId", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "currentIconUrl", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "serviceCombinationAliasId", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "isAliasingView", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "videoTitle", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "videoURL", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "howToVideoVisible", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "levelOneAliasList", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "levelTwoAliasList", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "levelThreeAliasList", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "serviceCodeWOType", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "loading", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "selectAlias", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "isChangeServiceComboByQuestion", void 0);
    __decorate([
        observable
    ], ProblemStore.prototype, "beforeServiceCodeId", void 0);
    __decorate([
        computed
    ], ProblemStore.prototype, "problemCaseCadeName", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "setServiceComboByQuestionData", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "browserBack", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "clear", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "initProblem", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "onChangeServiceCombo", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "backLevelQuestion", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "setProblemLevel", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "setLastLevel", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "getClientServiceComboAlias", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "handleLevelData", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "setProblemAlias", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "getServiceCodeWOType", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "revertProblemData", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "setProblemData", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "setHowToVideoVisible", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "setSelectAlias", null);
    __decorate([
        action.bound
    ], ProblemStore.prototype, "howToVideoCreateCancelWO", null);
    return ProblemStore;
}());
export default ProblemStore;
